import React from 'react'
import './index.css'

class PullDown extends React.Component{

  constructor(props) {

    super(props)
    this.state = {
      offset: 0,
      pulling: false,
      loading:false
    }

    this.__container = null
    this.__eventType = null
    this.__self = null
    this.__lastPageY = 0
    this.__threshold = 0

  }

  componentDidMount() {

    this.__container = document.querySelector(this.props.container) || this.refs.content.parentNode
    this.__self = this.refs.content
    this.__threshold = this.props.threshold || 200
    this.__sensitivity = this.props.sensitivity || .4
    this.__enablePull = typeof this.props.enablePull === 'boolean' ? this.props.enablePull : true
    this.__enablePush = typeof this.props.enablePush === 'boolean' ? this.props.enablePush : true

  }

  render() {
    let { loading } = this.state
    let className = this.props.className || this.props.class
    console.log("pulling",loading)
    return (
      <div
        ref="content"
        id={this.props.id || 'react-pulldown'}
        className={'react-pulldown ' + className}
        onTouchStart={(e) => this.handleTouchStart(e)}
        onTouchMove={(e) => this.handleTouchMove(e)}
        onTouchEnd={(e) => this.handleTouchEnd(e)}
        style={{
          minHeight: this.props.minHeight || '100%', 
          WebkitTransition: this.state.pulling ? 'none' : 'transform .3s',
          WebkitTransform: 'translateZ(0) translateY(' + this.state.offset / (1 / this.__sensitivity) + 'PX)',
          transition: this.state.pulling ? 'none' : 'transform .3s',
          transform: 'translateZ(0)  translateY(' + this.state.offset / (1 / this.__sensitivity) + 'PX)'
        }}
        >
          <div className="react-pulldown-background-layer">
            {
               loading ?   <div className="react-pulldown-top-tip">正在加载数据...</div> :<div className="react-pulldown-top-tip">{this.props.topTip || this.props.tip}</div>
               
            }
            {
              this.props.hasData == 'only' ? null : (
                this.props.hasData ?  <div className="react-pulldown-bottom-tip">{this.props.bottomTip}</div> : <div className="react-pulldown-bottom-tip">没有更多数据...</div>
              )
            }
           
          </div>
          {this.props.children}
        </div>
    )

  }

  handlePullCancel() {

    typeof this.props.onPullCancel === 'function' && this.props.onPullCancel()

  }

  handlePullDown() {

    typeof this.props.onPullDown === 'function' && this.props.onPullDown()

  }

  handlePushCancel() {

    typeof this.props.onPushCancel === 'function' && this.props.onPushCancel()

  }

  handlePushUp() {

    typeof this.props.onPushUp === 'function' && this.props.onPushUp()

  }

  handleTouchStart(e) {
    
    let containerHeight = this.__container.getBoundingClientRect().height
    let contentHeight = this.__self.getBoundingClientRect().height
    let scrollTop = this.__container.scrollTop
    let scrollBottom = contentHeight - containerHeight - scrollTop

    console.log("scrollBottom",scrollBottom)

    if ((scrollTop <= 5 || scrollBottom <= 5) && (this.__enablePull || this.__enablePush)) {

      this.__lastPageY = e.touches[0].pageY
      this.setState({
        pulling: true
      })

    }

  }

  handleTouchEnd() {

    let containerHeight = this.__container.getBoundingClientRect().height
    let contentHeight = this.__self.getBoundingClientRect().height
    let scrollTop = this.__container.scrollTop
    let scrollBottom = contentHeight - containerHeight - scrollTop

    console.log("offset=======offset",this.state.offset,this.__threshold,scrollTop,scrollBottom)


    if (scrollTop <= 5 || scrollBottom <= 5 ) {

      if (Math.abs(this.state.offset) < this.__threshold) {

        if (this.state.offset < 0) {
          this.handlePushCancel()
        } else if(this.state.offset > 0) {
          this.handlePullCancel()
        } else {

          if (this.__eventType === 'pull') {
            this.handlePullCancel()
          } else if (this.__eventType === 'push') {
            this.handlePushCancel()
          }

        }

      } else {
        console.log('this.props.hasData',this.props.hasData)
        if (this.state.offset < 10 && this.props.hasData) {

          setTimeout(()=>{
            this.handlePushUp()
          },50)
          
        } else {  

          
          this.handlePullDown()
        }

      }

      this.__eventType = null
      // this.setState({
      //     pulling: false,
      //     offset: 0
      //   })

      this.setState({
          loading: true 
        })
      setTimeout(()=>{
        this.setState({
          pulling: false,
          offset: 0,
          loading: false 
        })
      },1000)
      

    }

  }

  handleTouchMove(e) {

    let containerHeight = this.__container.getBoundingClientRect().height
    let contentHeight = this.__self.getBoundingClientRect().height
    let scrollTop = this.__container.scrollTop
    let scrollBottom = contentHeight - containerHeight - scrollTop

    if (scrollTop <= 5 && this.__enablePull) {

      let offset = e.touches[0].pageY - this.__lastPageY
      offset < 0 && (offset = 0)
      offset > this.__threshold && (offset = this.__threshold)
      offset > 0 &&  e.preventDefault()

      this.__eventType = 'pull'

      typeof this.props.onPullMove === 'function' && this.props.onPullMove({
        offset: offset,
        threshold: this.__threshold,
        sensitivity: this.__sensitivity
      })

      this.setState({ offset })

    } else if (scrollBottom <= 5 && this.__enablePush) {

      let offset = e.touches[0].pageY - this.__lastPageY
      offset > 0 && (offset = 0)
      offset < this.__threshold * -1 && (offset = this.__threshold * -1)
      offset < 0 &&  e.preventDefault()

      this.__eventType = 'push'

      typeof this.props.onPushMove === 'function' && this.props.onPushMove({
        offset: offset,
        threshold: this.__threshold,
        sensitivity: this.__sensitivity
      })

      this.setState({ offset })

    }

  }

}

export default PullDown